export default {"src":"/_next/static/media/Terraform.3a10c2c7.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};